<template>
  <div
    ref="track"
    class="swipe-action"
    :class="{
      dragging: dragging,
      confirmed: confirmed
    }"
    @mousedown.prevent="startDrag"
    @touchstart.prevent="startDrag"
  >
    <div
      :class="['swipe-action__overlay',{ off: confirmed}]"
      :style="{ width: overlayWidth + 'px' }"
    ></div>

    <div class="swipe-action__content">
      <span class="swipe-action__label">
        {{ confirmed ? successText : text }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "Arraste para confirmar"
    },
    successText: {
      type: String,
      default: "Confirmado"
    },
    threshold: {
      type: Number,
      default: 0.85
    },
    resetOnFail: {
      type: Boolean,
      default: true
    },
    startArea: {
      type: Number,
      default: 0.2
    }
  },
  data () {
    return {
      dragging: false,
      confirmed: false,
      currentX: 0,
      maxX: 0,
      startClientX: 0,
      startFromX: 0
    }
  },
  computed: {
    overlayWidth() {
      if (this.currentX < 0) return 0
      if (this.currentX > this.maxX) return this.maxX
      return this.currentX
    }
  },
  mounted() {
    this.updateBounds()

    window.addEventListener("mousemove", this.onMove)
    window.addEventListener("mouseup", this.endDrag)
    window.addEventListener("touchmove", this.onMove, { passive: false })
    window.addEventListener("touchend", this.endDrag)
    window.addEventListener("resize", this.updateBounds)
  },

  beforeUnmount() {
    window.removeEventListener("mousemove", this.onMove)
    window.removeEventListener("mouseup", this.endDrag)
    window.removeEventListener("touchmove", this.onMove)
    window.removeEventListener("touchend", this.endDrag)
    window.removeEventListener("resize", this.updateBounds)
  },

  methods: {
    updateBounds() {
      if (!this.$refs.track) return
      this.maxX = this.$refs.track.offsetWidth
    },
    getClientX(event) {
      if (event.touches && event.touches.length) {
        return event.touches[0].clientX
      }

      if (event.changedTouches && event.changedTouches.length) {
        return event.changedTouches[0].clientX
      }

      return event.clientX
    },
    startDrag(event) {
      if (this.confirmed) return

      this.updateBounds()

      const rect = this.$refs.track.getBoundingClientRect()
      const clientX = this.getClientX(event)
      const localX = clientX - rect.left

      if (localX < 0 || localX > this.maxX * this.startArea) {
        return
      }

      this.dragging = true
      this.startClientX = clientX
      this.startFromX = 0
      this.currentX = Math.max(0, localX)
    },
    onMove(event) {
      if (!this.dragging || this.confirmed) return

      if (event.cancelable) {
        event.preventDefault()
      }

      const clientX = this.getClientX(event)
      let nextX = this.startFromX + (clientX - this.startClientX)

      if (nextX < 0) nextX = 0
      if (nextX > this.maxX) nextX = this.maxX

      this.currentX = nextX
    },
    endDrag() {
      if (!this.dragging || this.confirmed) return

      this.dragging = false

      const progress = this.maxX ? this.currentX / this.maxX : 0

      if (progress >= this.threshold) {
        this.currentX = this.maxX
        this.confirmed = true
        this.$emit("confirm")
        return
      }

      if (this.resetOnFail) {
        this.currentX = 0
      }
    },
    reset() {
      this.dragging = false
      this.confirmed = false
      this.currentX = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.swipe-action {
  position: relative;
  width: 100%;
  height: auto;
  border-radius: $border-radius-small;
  overflow: hidden;
  padding: $hmg_mid;
  cursor: pointer;
  user-select: none;
  -webkit-user-select: none;
  touch-action: none;
  background: $color-success;
  color: $color-secondary;
  // box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);
  transition: transform 0.2s ease, background 0.2s ease;

  display: flex;
  align-items: center;
  justify-content: center;

  &.dragging {
    transform: scale(0.995);
  }

  &.confirmed {
    background: $color-success-2;
  }

  &__overlay {
    position: absolute;
    inset: 0 auto 0 0;
    width: 0;
    height: 100%;
    background: rgba(0, 0, 0, 0.2);
    pointer-events: none;
    transition: width 0.18s ease;
    z-index: 1;

    &.off {
      opacity: 0;
    }
  }

  &.dragging &__overlay {
    transition: none;
  }

  &__content {
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 0 $hmg_mid;
    text-align: center;
  }

  &__label {
    font-size: 2rem;
    font-weight: 700;
    // letter-spacing: 0.2px;
    white-space: nowrap;
    pointer-events: none;
  }
}
</style>